import React, { useState } from 'react';
import { sendPasswordResetEmail } from '../../firebase-config';
import Button from '../Shared/Button';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    sendPasswordResetEmail(email)
      .then(() => {
        setMessage('A password reset email has been sent to your email address.');
        setFormSubmitted(true);
      })
      .catch((error) => {
        setMessage('An error occurred while sending the password reset email.');
      });
  }



  return (
    <div className="mainDiv">
      <section className='mainSection'>
        <div className="loginDiv">
          <h2 className="loginTitle">Reset password</h2>
          <p className="loginSubtitle">To reset your password, enter your email address.<br /> A link will be sent to you with instructions on how to reset your password.</p>
          {!formSubmitted ? (
            <form className="formDiv" onSubmit={handleSubmit}>
              <label className='emailLabel' htmlFor="email">Email:</label>
              <input
                className='loginInput'
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div className="confirm-button-container">
              <Button buttonStyle='blue' type='submit' text='Confirm'/>
              </div>
            </form>
          ) : (
            <p style={{ color: "black" }}>{message}</p>
          )}
        </div>
      </section>
    </div>

  );
}

export default ResetPassword;
